import { defineComponent as c, createElementBlock as r, openBlock as n, Fragment as i, renderList as u, normalizeClass as d, createBlock as m, createCommentVNode as f, resolveDynamicComponent as p, toRaw as I } from "vue";
const _ = { class: "w-full list-none" }, h = ["id", "aria-hidden"], v = /* @__PURE__ */ c({
  name: "RevCarouselItems",
  __name: "CarouselItems",
  props: {
    currentIndex: {},
    currentIndexId: {},
    items: {}
  },
  setup(o) {
    const s = o;
    function t(a) {
      return a === s.currentIndex;
    }
    return (a, k) => (n(), r("ul", _, [
      (n(!0), r(i, null, u(o.items, (l, e) => (n(), r("li", {
        id: t(e) ? s.currentIndexId : void 0,
        key: e,
        "aria-hidden": !t(e),
        class: d(["flex w-full list-none justify-center motion-safe:animate-fade-in", t(e) ? "block" : "hidden"])
      }, [
        l !== null ? (n(), m(p(I(l)), { key: 0 })) : f("", !0)
      ], 10, h))), 128))
    ]));
  }
});
export {
  v as default
};
